export const getIsTxHash = value => /^[a-f0-9]{64}$/.test(value)
